import { SOUND_EDITION_V2_ABI } from '../../abi/sound-edition-v2.mjs';
import { SUPER_MINTER_ABI, SUPER_MINTER_ADDRESS } from '../../abi/super-minter.mjs';
import { getTierCurrentMaxMintable } from '../../helpers/tierCurrentMaxMintable.mjs';

async function getMintEligibility(client, { editionAddress, tier, scheduleNum, collectorAddress, merkleProvider }) {
  const [numberMintedOnSchedule, scheduleInfo, tierInfo] = await client.multicall({
    contracts: [
      {
        abi: SUPER_MINTER_ABI,
        address: SUPER_MINTER_ADDRESS,
        functionName: "numberMinted",
        args: [editionAddress, tier, scheduleNum, collectorAddress]
      },
      {
        abi: SUPER_MINTER_ABI,
        address: SUPER_MINTER_ADDRESS,
        functionName: "mintInfo",
        args: [editionAddress, tier, scheduleNum]
      },
      {
        abi: SOUND_EDITION_V2_ABI,
        address: editionAddress,
        functionName: "tierInfo",
        args: [tier]
      }
    ],
    allowFailure: false
  });
  const { paused, mode, maxMintable, minted, maxMintablePerAccount } = scheduleInfo;
  if (paused) {
    return {
      numberMintedOnSchedule,
      remainingEligibility: 0
    };
  }
  const tierCurrentMax = tierInfo.mintConcluded ? 0 : Math.max(getTierCurrentMaxMintable(tierInfo) - tierInfo.minted, 0);
  const availableOnSchedule = maxMintable - minted;
  const remainingPerAccountLimit = maxMintablePerAccount - numberMintedOnSchedule;
  const remainingEligibility = Math.min(availableOnSchedule, remainingPerAccountLimit, tierCurrentMax);
  if (mode === 0) {
    return {
      numberMintedOnSchedule,
      remainingEligibility
    };
  }
  if (mode === 1) {
    const { merkleRoot } = scheduleInfo;
    if (!merkleProvider) {
      throw new Error("Merkle provider required to check allowlist eligibility!");
    }
    const proof = await merkleProvider.merkleProof({ merkleRoot, userAddress: collectorAddress });
    if (!proof?.length) {
      return {
        numberMintedOnSchedule,
        remainingEligibility: 0
      };
    }
    return {
      numberMintedOnSchedule,
      remainingEligibility
    };
  } else if (mode === 2) {
    throw new Error("not implemented");
  } else {
    throw new Error("unknown minting mode");
  }
}

export { getMintEligibility };
